import { type MotionValue, easeOut, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { type RefObject, useRef } from "react";

/** Extra image inset beyond the clip. Must stay larger than the y travel. */
export const SECTION_FOUR_PARALLAX_BLEED_PERCENT = 12;

/** Image-layer y travel while the stats photo clip crosses the viewport. */
export const SECTION_FOUR_PARALLAX_Y_PERCENT = 8;

export const SECTION_FOUR_PARALLAX_Y = [
	`-${SECTION_FOUR_PARALLAX_Y_PERCENT}%`,
	`${SECTION_FOUR_PARALLAX_Y_PERCENT}%`,
] as const;

export const SECTION_FOUR_PARALLAX_SCROLL_OFFSET = ["start end", "end start"] as const;

export type TSectionFourParallax = {
	clipRef: RefObject<HTMLDivElement | null>;
	imageY: MotionValue<string>;
};

/**
 * Slight desk-photo parallax as the S4 stats clip crosses the viewport, including
 * the S3-cover handoff. Title, glass cards, and footnote stay untransformed.
 */
export function useSectionFourParallax(): TSectionFourParallax {
	const clipRef = useRef<HTMLDivElement>(null);
	const reducedMotion = useReducedMotion();
	const { scrollYProgress } = useScroll({
		target: clipRef,
		offset: [...SECTION_FOUR_PARALLAX_SCROLL_OFFSET],
	});
	const imageY = useTransform(scrollYProgress, [0, 1], reducedMotion ? ["0%", "0%"] : [...SECTION_FOUR_PARALLAX_Y], {
		ease: easeOut,
	});
	return { clipRef, imageY };
}
